// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import './assets/css/tokens.css'
import './assets/css/typography.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as Sentry from "@sentry/vue";


Vue.config.productionTip = false
import 'expose-loader?$!expose-loader?jQuery!jquery'

Sentry.init({
  Vue,
  dsn: "https://254e7d9258067d01a580ea3ba65936e0@o576649.ingest.us.sentry.io/4510520238669824"
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js